import { Component, OnDestroy, OnInit } from '@angular/core';
import { toastAnimations, ToastAnimationState } from '../config/toast.animation';
import { defaultToastConfig, ToastConfig, ToastData } from '../config/toast.config';
import { ToastRef } from '../config/toast.ref';
import { Router } from '@angular/router';

@Component({
  selector: 'kion-full-width-toast',
  templateUrl: './full-width-toast.component.html',
  styleUrls: ['./full-width-toast.component.scss'],
  animations: [toastAnimations.fadeToast],
})
export class FullWidthToastComponent implements OnInit, OnDestroy {

  animationState: ToastAnimationState = 'default';
  iconType: string;
  private delayClosing: number;
  private closeAutomatic:boolean;
  private intervalId: number;
  toastConfig: ToastConfig = defaultToastConfig;

  constructor(
    readonly data: ToastData,
    readonly ref: ToastRef,
    private router: Router
  ) {
    this.iconType = data.type === 'success' ? 'done' : data.type;
	this.delayClosing = data.hideAfterTime ? data.hideAfterTime : 5000;
	this.closeAutomatic = (data.hideAutomatic === undefined) ? true : data.hideAutomatic;
  }

  ngOnInit() {
	if (this.closeAutomatic)
	{
    	// @ts-ignore
	    this.intervalId = setTimeout(() => this.animationState = 'closing', this.delayClosing);
	}
  }

  ngOnDestroy() {
	if (this.closeAutomatic)
	{
    	clearTimeout(this.intervalId);
	}
  }

  close() {
    this.ref.close();
  }

  onFadeFinished(event: AnimationEvent) {
    // @ts-ignore
    const isFadeOut = event.toState === 'closing';
    const itFinished = this.animationState === 'closing';
    if (isFadeOut && itFinished) {
      this.close();
    }
  }

  goToRoute() {
    this.router.navigate(this.data.route).then(() => { });
  }

}
